import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export const Hint = ({ children, className }: { children: ReactNode; className?: string }) => (
  <p className={cn('mt-label max-w-prose-line text-meta text-muted', className)}>{children}</p>
);
